/**
 * ARN services API names.
 */
export enum ArnClientServiceKey {
  auth = 'auth',
  condition = 'condition',
  data = 'data',
  http = 'http',
  i18n = 'i18n',
  log = 'log',
  nft = 'nft',
  track = 'track',
}

/**
 * Any type providing per ARN services.
 */
export type ArnClientServiceIndexed<T = any> = {
  readonly [key in ArnClientServiceKey]: T;
};
